var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { attachRegionsHover, attachIndexXHover, attachPolarSliceHover } from '../core/interaction';
import { registerDashboard } from '../../registryCore';
import { createWidgetGroup, num, setState } from '../../helpers';
import { getActiveDashboard } from '../../theme';
import { layoutSankey, layoutChord } from '../core/sankey';
import { arcSectorPath } from '../../../renderers/arcSector';
import { layoutStreamgraph, streamTooltipLabel } from '../core/streamLayout';
var SAMPLE_FLOW_NODES = [
    { id: 'a', label: 'Source' },
    { id: 'b', label: 'Process' },
    { id: 'c', label: 'Sink' },
];
var SAMPLE_FLOW_LINKS = [
    { source: 'a', target: 'b', value: 40 },
    { source: 'b', target: 'c', value: 35 },
];
registerDashboard('sankeyChart', function (props, app) {
    var _a, _b;
    var width = num(props, 'width', 400);
    var height = num(props, 'height', 220);
    var nodes = (_a = props.nodes) !== null && _a !== void 0 ? _a : SAMPLE_FLOW_NODES;
    var links = (_b = props.links) !== null && _b !== void 0 ? _b : SAMPLE_FLOW_LINKS;
    var group = createWidgetGroup(app, 'sankeyChart', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var layout = layoutSankey(nodes, links, width, height);
    layout.links.forEach(function (l) {
        group.add(app.path({ d: l.path, fill: null, stroke: getActiveDashboard().flowLink, strokeWidth: Math.max(2, l.value / 10), listening: false }));
    });
    layout.nodes.forEach(function (n) {
        group.add(app.rect({ x: n.x, y: n.y, width: n.width, height: n.height, fill: getActiveDashboard().primary, listening: false }), app.text({ text: n.label, x: n.x, y: n.y - 12, fontSize: 10, fill: getActiveDashboard().text, listening: false }));
    });
    attachRegionsHover(app, group, props, width, height, layout.nodes.map(function (n) { return ({
        x: n.x - 10,
        y: n.y,
        width: n.width + 20,
        height: n.height,
        label: n.label,
        payload: { id: n.id, label: n.label },
    }); }));
    setState(group, { width: width, height: height, nodes: nodes, links: links });
    return group;
});
registerDashboard('chordChart', function (props, app) {
    var _a, _b;
    var size = num(props, 'size', 220);
    var labels = (_a = props.labels) !== null && _a !== void 0 ? _a : [];
    var matrix = (_b = props.matrix) !== null && _b !== void 0 ? _b : [
        [0, 5, 3],
        [4, 0, 2],
        [1, 3, 0],
    ];
    var group = createWidgetGroup(app, 'chordChart', props);
    group.add(app.rect({ width: size, height: size, fill: getActiveDashboard().chartBg, listening: true }));
    var chord = layoutChord(matrix, size);
    chord.ribbons.forEach(function (ribbon) {
        group.add(app.path({
            d: ribbon.path,
            fill: getActiveDashboard().flowLink,
            opacity: 0.35 + (ribbon.value / 10) * 0.15,
            stroke: null,
            listening: false,
        }));
    });
    chord.segments.forEach(function (seg) {
        var _a;
        group.add(app.path({
            d: arcSectorPath(chord.cx, chord.cy, chord.outerR, seg.startAngle, seg.endAngle, chord.innerR),
            fill: getActiveDashboard().series[seg.index % getActiveDashboard().series.length],
            stroke: getActiveDashboard().pieStroke,
            strokeWidth: 1,
            listening: false,
        }));
        var mid = (seg.startAngle + seg.endAngle) / 2;
        var lr = (chord.outerR + chord.innerR) / 2;
        var lx = chord.cx + lr * Math.cos(mid);
        var ly = chord.cy + lr * Math.sin(mid);
        var name = (_a = labels[seg.index]) !== null && _a !== void 0 ? _a : "N".concat(seg.index + 1);
        group.add(app.text({
            text: name,
            x: lx - 10,
            y: ly - 6,
            fontSize: 9,
            fill: getActiveDashboard().text,
            listening: false,
        }));
    });
    attachPolarSliceHover(app, group, props, size, chord.segments.map(function (s) { return s.value; }), chord.segments.map(function (s, i) { var _a; return (_a = labels[i]) !== null && _a !== void 0 ? _a : "node ".concat(i + 1, ": ").concat(s.value); }));
    setState(group, { size: size, matrix: matrix, labels: labels });
    return group;
});
registerDashboard('alluvialChart', function (props, app) {
    var _a;
    var width = num(props, 'width', 400);
    var height = num(props, 'height', 200);
    var stages = (_a = props.stages) !== null && _a !== void 0 ? _a : [
        ['A1', 'A2'],
        ['B1', 'B2', 'B3'],
        ['C1', 'C2'],
    ];
    var group = createWidgetGroup(app, 'alluvialChart', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var colW = width / stages.length;
    var regions = [];
    stages.forEach(function (col, ci) {
        var step = height / (col.length + 1);
        col.forEach(function (label, ri) {
            var x = ci * colW + 10;
            var y = step * (ri + 1);
            regions.push({ x: x, y: y, width: colW - 20, height: 24, label: label });
            group.add(app.rect({ x: x, y: y, width: colW - 20, height: 24, fill: getActiveDashboard().series[ri % getActiveDashboard().series.length], cornerRadius: 4, listening: false }), app.text({ text: label, x: x + 6, y: y + 5, fontSize: 10, fill: getActiveDashboard().text, listening: false }));
            if (ci < stages.length - 1) {
                var nx = (ci + 1) * colW + 10;
                var ny = step * (ri + 1) + 12;
                group.add(app.path({ d: "M ".concat(x + colW - 20, " ").concat(y + 12, " C ").concat(x + colW, " ").concat(y + 12, " ").concat(nx - 20, " ").concat(ny, " ").concat(nx, " ").concat(ny), fill: null, stroke: getActiveDashboard().flowLink, strokeWidth: 8, listening: false }));
            }
        });
    });
    attachRegionsHover(app, group, props, width, height, regions);
    setState(group, { width: width, height: height, stages: stages });
    return group;
});
registerDashboard('streamgraph', function (props, app) {
    var _a, _b;
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 150);
    var series = (_a = props.series) !== null && _a !== void 0 ? _a : [
        [10, 12, 8, 14, 11],
        [8, 10, 12, 9, 13],
        [6, 7, 9, 11, 8],
    ];
    var names = (_b = props.seriesNames) !== null && _b !== void 0 ? _b : series.map(function (_, i) { return "S".concat(i + 1); });
    var group = createWidgetGroup(app, 'streamgraph', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var layers = layoutStreamgraph(series, width, height);
    var len = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(series.map(function (s) { return s.length; })), false), [1], false));
    layers.forEach(function (layer) {
        group.add(app.path({
            d: layer.path,
            fill: getActiveDashboard().series[layer.index % getActiveDashboard().series.length],
            opacity: 0.82,
            stroke: getActiveDashboard().chartBg,
            strokeWidth: 0.5,
            listening: false,
        }));
    });
    attachIndexXHover(app, group, props, { plotX: 24, plotY: 0, plotWidth: width - 48, plotHeight: height }, len, function (i) { return streamTooltipLabel(series, i, names); });
    setState(group, { width: width, height: height, series: series, names: names });
    return group;
});
